<template>
  <v-dialog
    v-model="transferDialog"
    :disabled="!isPermission || isDisabled"
    max-width="500px"
    min-width="500px">
    <v-btn dark color="#F5F5F5" class="transferBtn UXbtn" slot="activator" @click="fetchTakeOverAgents" :disabled="!isPermission">
      <i class="UXicon-transfer"></i>
      転送
    </v-btn>
    <div class="layerPopup managerDist">
      <div class="layerTit">他のオペレーターへ転送</div>
      <div class="layerContent">
        <div class="transferLayerCon">
          <div class="in">
            <div class="box" style="padding-top: 6px">
              <dl>
                <dt style="color:#919191">転送するオペレーターを選択</dt>
                <dd>
                  <VuePerfectScrollbar class="userScroll larger scrollBoxCustom">
                    <table class="distTblCon">
                      <tr v-for="(agent, index) in availableAgentsList"
                          :key="index"
                          :class="{'on': selectedAgentId === agent.id}"
                          @click="selectAgent(agent.id)">
                        <td style="width: 30px">
                          <v-radio-group class="UXradio" v-model="selectedAgentId" hide-details>
                            <v-radio :value="agent.id"></v-radio>
                          </v-radio-group>
                        </td>
                        <td style="padding-left:0;padding-right:0">
                          <div>
                            <!--<div class="onlineIcon"></div>-->
                            <!--상담사 이름 툴팁-->
                            <span>({{ agent.status }}) {{agent.name}}</span>
                          </div>
                        </td>
                      </tr>
                    </table>
                    <div v-if="availableAgentsList.length === 0" class="UXnotData larger" style="height: 370px;">移動が可能なオペレーターがいません。</div>
                  </VuePerfectScrollbar>
                </dd>
                <dt style="margin-top: 20px; color: #919191">担当者へのメッセージ<span class="template-name-length gray">(<span class="colorBlue">{{ takeOverMemoLength }}</span>/{{ takeOverMemoLimit }})</span></dt>
                <dd>
                  <v-textarea
                    v-model="takeOverMemo"
                    @keydown="checkTextLimit($event,'takeOverMemo',takeOverMemoLimit)"
                    @keyup="checkTextLimit($event,'takeOverMemo',takeOverMemoLimit)"
                    hide-details
                    no-resize
                    outline
                    height="145"
                    class="UXtextarea"
                    placeholder="内容を入力してください。"
                  ></v-textarea>
                </dd>
                <div class="cenBtn">
                  <v-btn outline round class="UXbtn" @click.native="closeTransferDialog">キャンセル</v-btn>
                  <v-btn round dark color="#ff8c8c" class="UXbtn" :loading="loading" @click.native="sendTransfer">確認</v-btn>
                </div>
              </dl>
            </div>
          </div>
        </div>
      </div>
      <div class="layerClose">
        <v-btn flat icon @click="closeTransferDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import helper from 'util/helpers'
import {mapGetters, mapMutations} from 'vuex'
// import messageStore from 'util/messages'
import eventBus from '@/event_bus'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  name: 'transfer_dialog',
  props: ['brandId', 'agentId', 'chatRoomId', 'status', 'isDisabled', 'isPermission'],
  created () {
    // this.fetchTakeOverAgents()
  },
  components: {
    VuePerfectScrollbar
  },
  computed: {
    ...mapGetters([
      'activeChatRoomList',
      'transferredChatRoomList'
    ]),
    isActiveStatus () {
      return this.status === 'ACTIVE' || this.status === 'TRANSFER'
    }
  },
  watch: {
    status (newStatus) {
      // 이관 대상 상담사 목록 조회
      this.fetchTakeOverAgents()
    },
    takeOverMemo () {
      this.takeOverMemoLength = this.takeOverMemo.length
    }
  },
  data () {
    return {
      transferDialog: false,
      selectedAgentId: -1,
      availableAgentsList: [],
      takeOverMemo: '',
      loading: false,
      takeOverMemoLimit: 1000,
      takeOverMemoLength: 0
    }
  },
  methods: {
    ...mapMutations([
      'deleteToActiveChatRoomList',
      'deleteTabChatRoom',
      'removeTransferChatRooms',
      'addSummaryChatRoom'
    ]),
    selectAgent (agentId) {
      this.selectedAgentId = agentId
    },
    fetchTakeOverAgents () {
      if (this.isActiveStatus) {
        if (this.loading) return

        this.loading = true
        this.axios.get('/api/brand/searchConsultableAgents', {
          params: {
            brandId: this.brandId
          }
        }).then(res => {
          if (res.data.code !== 0) throw res.data.message

          this.availableAgentsList = res.data.data.map(agent => {
            return {id: agent.agentId, name: agent.name, status: agent.workingStatusLabel}
          })
          this.availableAgentsList.splice(this.availableAgentsList.findIndex(agent => agent.id === this.agentId), 1)
          this.availableAgentsList.sort((left, right) => left.name.localeCompare(right.name))
        }, () => this.$alertMsg(this.$const.SYS_ERR))
          .catch(errorMsg => this.$alertMsg(errorMsg))
          .finally(() => {
            this.loading = false
          })
      }
    },
    closeTransferDialog () {
      this.transferDialog = false
    },
    sendTransfer () {
      if (this.loading) return

      this.loading = true
      this.axios.post('/api/chat/takeOverChatRoom', {
        agentId: this.agentId,
        chatRoomId: this.chatRoomId,
        nextAgentId: this.selectedAgentId,
        takeOverMemo: this.takeOverMemo
      }).then(res => {
        if (res.data.code !== 0) throw res.data.message
        let addSummary = false
        let selectedChatRoom = helper.findByChatRoomId(this.activeChatRoomList, this.chatRoomId)
        if (!helper.isObjectValid(selectedChatRoom)) {
          selectedChatRoom = helper.findByChatRoomId(this.transferredChatRoomList, this.chatRoomId)
        }

        // 상담 이관 정보 표시를 위해 이관 정보 추가
        const transferAgent = this.availableAgentsList.find(agent => agent.id === this.selectedAgentId)
        if (selectedChatRoom) {
          selectedChatRoom.afterAgentName = transferAgent.name
          selectedChatRoom.takeOverMemo = this.takeOverMemo
        }

        this.deleteToActiveChatRoomList(selectedChatRoom)
        this.removeTransferChatRooms(selectedChatRoom)
        if (selectedChatRoom.status === 'ACTIVE') {
          // 처음 이전시 후처리 데이터가 없으므로 추가해줌.
          addSummary = true
          this.addSummaryChatRoom(selectedChatRoom)
        }
        // messageStore.deleteMessageStore(selectedChatRoom.chatRoomId)
        this.closeTransferDialog()
        eventBus.$emit('takeOverMessage-clear')
        this.deleteTabChatRoom(selectedChatRoom)
        eventBus.$emit('transfer-chatRoom', selectedChatRoom, addSummary)
      }, () => this.$alertMsg(this.$const.SYS_ERR))
        .catch(errorMsg => this.$alertMsg(errorMsg))
        .finally(() => {
          this.loading = false
        })
    },
    checkTextLimit (event, key, limitCnt) {
      // 방향키 37~40 , backspace 8, delete key 46
      const isAllowKeyCodes = [8, 37, 38, 39, 40, 46]
      // 복사,붙혀넣기,전체선택
      const copyPaste = ((event.ctrlKey || event.metaKey) && (event.keyCode === 67 || event.keyCode === 86 || event.keyCode === 65))
      const allowed = isAllowKeyCodes.includes(event.keyCode) || copyPaste
      if (!allowed) {
        if (this[key] && this[key].length > limitCnt) {
          this[key] = this[key].substr(0, limitCnt)
        }
        if (this[key] && this[key].length >= limitCnt) {
          event.preventDefault()
          this.$toasted.clear()
          this.$toasted.error('最大入力文字数を超えました。')
        }
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/operation/fragments/chat_area/transfer_dialog.vue